import { useState } from "react";
import ReactPlayer from "react-player/file";
import { BasePlayer } from "./BasePlayer";

export const HLSURLPlayer = ({playerRef, playing, onProgress, onDuration, onSourceChange, playbackRate, volume, children, ...sessionProps}) => {
  const [url, setURL] = useState("");
  const [tmpUrl, setTmpUrl] = useState("")
  const [inputError, setInputError] = useState(false)

  const handleVideoLinking = () => {
    const nextUrl = tmpUrl.trim()
    if (!nextUrl || !ReactPlayer.canPlay(nextUrl)) {
      setInputError(true)
      return
    }
    setInputError(false)
    setTmpUrl(nextUrl)
    setURL(nextUrl)
  }

  return (
    <BasePlayer
      {...sessionProps}
      Player={ReactPlayer}
      url={url}
      playerRef={playerRef}
      playing={playing}
      onProgress={onProgress}
      onDuration={onDuration}
      onSourceChange={onSourceChange}
      playbackRate={playbackRate}
      volume={volume}
      config={{ file: { forceHLS: true } }}
      videoInput={
        <>
          <label className="source-field source-url">串流影片網址<input aria-label="串流影片網址" value={tmpUrl} onChange={(e) => {setTmpUrl(e.target.value)}} placeholder="影片連結" /></label>
          <button onClick={handleVideoLinking}>連結影片</button>
          {inputError && <span className="video-url-error" role="alert" style={{ color: "#f87171" }}>請輸入可播放的影片連結</span>}
        </>
      }
    >
      {children}
    </BasePlayer>
  );
};
